/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />

((() => {
	'use strict';

	angular.module('app.hilo.directives', []);

})());